import z from 'zod'

const alhenaChatEventBase = {
  event: z.literal('GAevent'),
  eventCategory: z.literal('alhena_chat'),
  eventElement03: z.literal('-'),
} as const

export const alhenaChatOpenBubbleSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C001'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('open_chat_bubble'),
  eventElement01: z.literal('-'),
  eventElement02: z.literal('-'),
})

export const alhenaChatCloseSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C002'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('close_chat'),
  eventElement01: z.literal('-'),
  eventElement02: z.literal('-'),
})

export const alhenaChatStartSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C003'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('start_chat'),
  eventElement01: z.literal('-'),
  eventElement02: z.literal('-'),
})

export const alhenaChatQueryValueSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C004'),
  eventAction: z.literal('text_input'),
  eventLabel: z.literal('query_value'),
  eventElement01: z.string(),
  eventElement02: z.literal('-'),
})

export const alhenaChatAttachmentSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C005'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('add_an_attachment'),
  eventElement01: z.string(),
  eventElement02: z.string(),
})

export const alhenaChatSendMessageSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C006'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('send_message'),
  eventElement01: z.string(),
  eventElement02: z.enum(['button', 'enter_key']),
})

export const alhenaChatSuggestedCategoriesSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C007'),
  eventAction: z.literal('element_visibility'),
  eventLabel: z.literal('suggested_categories'),
  eventElement01: z.string(),
  eventElement02: z.literal('-'),
})

export const alhenaChatSuggestedCategoryClickSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C008'),
  eventAction: z.literal('click_cta'),
  eventLabel: z.literal('suggested_category_click'),
  eventElement01: z.string(),
  eventElement02: z.string(),
})

export const alhenaChatSuggestedProductsSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C009'),
  eventAction: z.literal('element_visibility'),
  eventLabel: z.literal('suggested_products'),
  eventElement01: z.string(),
  eventElement02: z.string(),
})

export const alhenaChatSuggestedProductClickSchema = z.object({
  ...alhenaChatEventBase,
  eventID: z.literal('C010'),
  eventAction: z.literal('select_item'),
  eventLabel: z.literal('suggested_product_click'),
  eventElement01: z.string(),
  eventElement02: z.string(),
  eventElement03: z.string(),
})
